import * as React from 'react'

function VmChevronDownIcon({title, titleId, ...props}, svgRef) {
  return React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        fill: 'none',
        viewBox: '0 0 24 24',
        strokeWidth: 1.5,
        stroke: 'currentColor',
        'aria-hidden': 'true',
        ref: svgRef,
        'aria-labelledby': titleId,
      },
      props
    ),
    title
      ? React.createElement(
          'title',
          {
            id: titleId,
          },
          title
        )
      : null,
    React.createElement('path', {
      'aria-label': props?.['aria-label'],
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      d: 'M19.5 8.25l-7.5 7.5-7.5-7.5',
    })
  )
}

const ForwardRef = React.forwardRef(VmChevronDownIcon)
export default ForwardRef
